import Vue from "vue";
export default class Base {
    path;
    constructor(p) {
        this.path = `/${p}/`;
    }
    getPublicList() {
        return new Promise(resolve => {
            Vue.axios
                .get(`${this.path}list`)
                .then(res => {
                    return resolve(res.data.data);
                })
                .catch(() => {});
        });
    }
    getList(params) {
        return new Promise(resolve => {
            Vue.axios
                .get(this.path, { params })
                .then(res => {
                    return resolve(res.data.data);
                })
                .catch(() => {});
        });
    }
    getAllList(params) {
        return new Promise(resolve => {
            Vue.axios
                .get(`${this.path}get-all/`, { params })
                .then(res => {
                    return resolve(res.data.data);
                })
                .catch(() => {});
        });
    }
    getListWithoutPagination(params) {
        if (!params) params = {};
        params = Object.assign(params, { Records: 100000 });
        return new Promise(resolve => {
            Vue.axios
                .get(this.path, { params })
                .then(res => {
                    return resolve(res.data && res.data.data ? res.data.data : []);
                })
                .catch(() => {});
        });
    }
    getListAll(params) {
        return new Promise(resolve => {
            Vue.axios
                .get(this.path, { params })
                .then(res => {
                    return resolve(res.data || []);
                })
                .catch(() => {});
        });
    }
    getDetail(id) {
        return new Promise(resolve => {
            Vue.axios
                .get(this.path + id)
                .then(res => {
                    return resolve(res.data || {});
                })
                .catch(() => {
                    document.location.href = "/404";
                });
        });
    }
    add(params) {
        return new Promise(resolve => {
            Vue.axios
                .post(this.path, params)
                .then(res => {
                    return resolve(res);
                })
                .catch(() => {});
        });
    }
    edit(params, id) {
        return new Promise(resolve => {
            Vue.axios
                .put(this.path + id, params)
                .then(res => {
                    return resolve(res);
                })
                .catch(() => {});
        });
    }
    delete(id) {
        return new Promise(resolve => {
            Vue.axios
                .delete(this.path + id)
                .then(res => {
                    return resolve(res);
                })
                .catch(() => {});
        });
    }
}
